<script lang="ts" setup>
const props = defineProps<{
  text: string,
}>();

const copied = ref(false);

function copyToClipboard() {
  copied.value = true;
  navigator.clipboard.writeText(props.text);
  showInfoNotification('Copied to clipboard', 2000);
  setTimeout(() => { copied.value = false; }, 2000);
}
</script>

<template>

  <UButton
    :icon="copied ? 'i-heroicons-clipboard-document-check' : 'i-heroicons-clipboard-document'"
    color="gray"
    :padded="false"
    size="xs"
    variant="ghost"
    aria-label="Copy"
    @click.stop="copyToClipboard" />

</template>

<style>
</style>
